module.exports = __webpack_public_path__ + "static/media/6.22.1e851c9c.png";